import {makeZodI18nMap} from "zod-i18n-map";

export const customZodI18nMap = makeZodI18nMap({handlePath: false});
